import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock } from 'lucide-react';

const PostCard = ({ post, featured = false }) => {
  return (
    <article className={`group ${featured ? 'md:col-span-2' : ''}`}>
      <Link to={`/post/${post.slug}`} className="block">
        {/* Image */}
        <div className={`relative overflow-hidden rounded-lg mb-4 bg-gray-100 ${
          featured ? 'aspect-[16/9]' : 'aspect-[16/10] max-h-48'
        }`}>
          <img
            src={post.image}
            alt={post.title}
            onError={(e) => {
              if (e.currentTarget.dataset.fallback) return;
              e.currentTarget.dataset.fallback = '1';
              e.currentTarget.src = 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=500&fit=crop';
            }}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {featured && (
            <div className="absolute top-3 left-3 px-3 py-1 bg-black text-white text-xs font-medium rounded-full">
              Featured
            </div>
          )}
        </div>

        {/* Content */}
        <div>
          {/* Category */}
          <Link
            to={`/topics#${post.categorySlug}`}
            className="inline-block text-xs font-medium text-gray-600 hover:text-black transition-colors mb-3"
            onClick={(e) => e.stopPropagation()}
          >
            {post.category}
          </Link>

          {/* Title */}
          <h3 className={`font-light mb-3 group-hover:text-gray-600 transition-colors ${
            featured ? 'text-3xl md:text-4xl' : 'text-2xl'
          }`}>
            {post.title}
          </h3>

          {/* Excerpt */}
          <p className="text-gray-600 mb-4 leading-relaxed">
            {post.excerpt}
          </p>

          {/* Meta */}
          <div className="flex items-center space-x-4 text-sm text-gray-500">
            <div className="flex items-center space-x-2">
              <Calendar size={16} />
              <span>{new Date(post.date).toLocaleDateString('en-US', { 
                month: 'short', 
                day: 'numeric', 
                year: 'numeric' 
              })}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Clock size={16} />
              <span>{post.readTime}</span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
};

export default PostCard;
